import cloneDeep from "lodash.clonedeep";
import { questionIdToQuizIndexMapping } from "../dealershipQuiz/quizIndexMapping";
import { DEALERSHIP_CONFIG } from "../../config/dealershipConfig";

function preFillUpdateProfileQuestions(
  quizQuestions,
  user = {},
  quizIndexMapping = {}
) {
  if (!user?.profile) return [];
  const newQuizQuestions = cloneDeep(quizQuestions);

  newQuizQuestions[0]?.children.forEach((questionInstance, _) => {
    if (questionInstance?.prefill) {
      const quizIndexName =
        questionIdToQuizIndexMapping[questionInstance?.childQuestionId];
      questionInstance.prefill.call(
        questionInstance,
        user.profile?.quiz?.[quizIndexMapping[quizIndexName]]
      );
    }
  });
  return newQuizQuestions;
}

function preFillTestDriveandPreapprovalForm(quizQuestions, user) {
  const quizQuestion = cloneDeep(quizQuestions);

  const initialIndex = getQuizInitialIndex();

  const newQuizQuestionInstance = quizQuestion[initialIndex].children[0];

  if (newQuizQuestionInstance.prefill) {
    newQuizQuestionInstance.prefill.call(
      newQuizQuestionInstance,
      user.testDriveFinancePreApprovalInfo
    );
  }

  return quizQuestion;
}

export const quizQuestionsFactory = (
  baseURL,
  dealershipId,
  user,
  quizIndexMapping,
  recordingEnabled
) => {
  const pathname = window.location.pathname;
  switch (pathname) {
    case `${baseURL}matchmaker-quiz`:
      return recordingEnabled !== "3"
        ? cloneDeep(DEALERSHIP_CONFIG[dealershipId].quizQuestions)
        : cloneDeep(DEALERSHIP_CONFIG[dealershipId].optionalQuizQuestions);
    case `${baseURL}testdrive`:
      return preFillTestDriveandPreapprovalForm(
        DEALERSHIP_CONFIG[dealershipId].testDrivePreapprovalQuizQuestions,
        user
      );
    case `${baseURL}update-profile`:
      return preFillUpdateProfileQuestions(
        DEALERSHIP_CONFIG[dealershipId].updateProfileQuizQuestions,
        user,
        quizIndexMapping
      );
    default:
      return [];
  }
};

export const getQuizCount = (baseURL, dealershipId, recordingEnabled) => {
  const pathname = window.location.pathname;
  switch (pathname) {
    case `${baseURL}matchmaker-quiz`:
      return recordingEnabled !== "3"
        ? DEALERSHIP_CONFIG[dealershipId].quizQuestions.length
        : DEALERSHIP_CONFIG[dealershipId].optionalQuizQuestions.length;
    case `${baseURL}testdrive`:
      return DEALERSHIP_CONFIG[dealershipId].testDrivePreapprovalQuizQuestions
        .length;
    case `${baseURL}update-profile`:
      return DEALERSHIP_CONFIG[dealershipId].updateProfileQuizQuestions.length;
    default:
      return 0;
  }
};

export const getQuizInitialIndex = () => {
  //For now no logic extra logic for getting the initial quiz index
  return 0;
};

//THINK: WHY IS THE DEALERSHIP ID NEEDED HERE?
export const getQuizViewFwdBtnText = (
  baseURL,
  isLastQuestion,
  disable = false
) => {
  const pathname = window.location.pathname;
  switch (pathname) {
    case `${baseURL}matchmaker-quiz`:
      return isLastQuestion ? "Complete Check-In" : "Continue";
    case `${baseURL}testdrive`:
      return disable ? "Edit" : "Submit";
    case `${baseURL}update-profile`:
      return "Update";
    default:
      return "Continue";
  }
};

export const getQuizViewPrevBtnText = (
  baseURL,
  disable = false,
  currentQuestionView
) => {
  const pathname = window.location.pathname;
  switch (pathname) {
    case `${baseURL}matchmaker-quiz`:
      return "Back";
    case `${baseURL}testdrive`:
      return disable === null ||
        disable ||
        !currentQuestionView?.children?.[0]?.prefilled
        ? "Back"
        : "Cancel";
    case `${baseURL}update-profile`:
      return "Back";
    default:
      return "Continue";
  }
};

export const prevBtnFunctionSelector = (
  baseURL,
  disable = false,
  currentQuestionView
) => {
  const pathname = window.location.pathname;
  switch (pathname) {
    case `${baseURL}matchmaker-quiz`:
      return true;
    case `${baseURL}testdrive`:
      return (
        disable === null ||
        disable ||
        !currentQuestionView?.children?.[0]?.prefilled
      );
    case `${baseURL}update-profile`:
      return true;
    default:
      return true;
  }
};
